import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import DisableZoneModal from './DisableZoneModal';

import { Button, Text, H3, Panel, Dropdown, Small, Tabs, Table, Box } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, AddIcon, EditIcon, DeleteIcon } from '@bigcommerce/big-design-icons';

import { zonesIndex } from '../../redux/actions/zones';

const Zones = ({ payload, zones, loadZones }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeZone, setActiveZone] = useState(null);
  const [showDisableZoneModal, setShowDisableZoneModal] = useState(false);

  useEffect(() => {
    loadZones(payload);
  }, []);

  const showDisableModal = (id) => {
    let zone = zones.zones.find(zone => zone.id.split("#")[1] === id);

    console.log(zone);

    setActiveZone(zone);
    setShowDisableZoneModal(true);
  }

  const actionButtons = (id) => {
    let idOnly = id.split("#")[1];

    return(
      <>
        <Link to={`/zones/edit/${idOnly}`}>
          <Button
            variant="secondary"
            iconLeft={<EditIcon />}
            disabled={submitted}
            isLoading={submitted}
          >
            Edit
          </Button>
        </Link>

        <Button
          onClick={() => showDisableModal(idOnly)}
          variant="secondary"
          actionType="destructive"
          iconLeft={<DeleteIcon />}
          disabled={submitted}
          isLoading={submitted}
        >
          Disable
        </Button>
      </>
    )
  }

  const description = () => {
    return(
      <> 
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return (
    <>
      <PageHeader stripeBackground='#2c9c7c' helpLink="" />
      <SettingsPage title="Warehouse Zones" description={description()}>
        <Panel>
          <H3>Warehouse Zones</H3>
          { zones.status === 'success' && zones.zones.length > 0 &&
            <>
              <Table
                columns={[
                  { header: 'Label', hash: 'label', render: ({ label }) => label },
                  { header: 'Description', hash: 'description', render: ({ description }) => description },
                  { header: 'Priority', hash: 'priority', render: ({ priority }) => priority },
                  { header: 'Actions', hash: 'actions', render: ({ id }) => actionButtons(id) },
                ]}
                items={zones.zones}
                stickyHeader
              />
              <hr/>
              <Link to="/zones/new">
                <Button
                  iconLeft={<AddIcon />}
                  isLoading={submitted}
                  disabled={submitted}
                >
                  New Warehouse Zone
                </Button>
              </Link>
            </>
          }

          { zones.status !== 'success' &&
            <LoadingSpinner size="xxSmall" statusText="Loading warehouse zones"/>
          }

          { zones.status === 'success' && zones.zones.length === 0 &&
            <Box
              backgroundColor="warning10"
              border="box"
              borderRadius="normal"
              padding="medium"
            >
              <div className="text-center">
                <Text>No warehouse zones set. Create warehouse zones to see and manage them here.</Text>
                <Link to="/zones/new">
                  <Button
                    iconLeft={<AddIcon />}
                    isLoading={submitted}
                    disabled={submitted}
                  >
                    New Warehouse Zone
                  </Button>
                </Link>
              </div>
            </Box>
          }

        </Panel>
      </SettingsPage>

      <DisableZoneModal
        payload={payload}
        showDisableZoneModal={showDisableZoneModal}
        setShowDisableZoneModal={setShowDisableZoneModal}
        zone={activeZone}
        zoneId={activeZone?.id.split("#")[1]}
      />
    </>
  )
} 

const mapStateToProps = state => ({
  zones: state.zones,
});

const mapDispatchToProps = (dispatch) => ({
  loadZones: (payload) => dispatch(zonesIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Zones);